// ----------------------------------------------------------------
import { createFileRoute, useParams } from '@tanstack/react-router';
import FolderById from '@/pages/folder/folder-by-id';
import FolderByIdSkeleton from '@/pages/folder/folder-by-id/loading';
// ----------------------------------------------------------------

/**
 * Shown while the route's code-split chunk is still loading. The page is imported statically on purpose: the
 * router plugin already splits this route into its own chunk, so a `lazy()` on top only added one more network
 * round trip (route chunk → page chunk) before anything could render.
 */
const FolderByIdPending = () => {
  const params = useParams({ from: '/_authenticated-layout/group/$groupId/item/$folderId' });
  return <FolderByIdSkeleton folderId={params.folderId} />;
};

/**
 * The Route component is a file route that is used to render the folder by id page.
 * This is a route setup for '/folder/$folderId' route.
 */
export const Route = createFileRoute('/_authenticated-layout/group/$groupId/item/$folderId')({
  component: FolderById,
  pendingComponent: FolderByIdPending,
});
